import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import React, { useState, useContext } from "react";

import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import SettingsContext from "../../context/SettingsContext";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    overflow: "hidden",
    width: "100%",
    backgroundColor: "#f5f6fa",
    position: "relative",
  },
  root1: {
    backgroundColor: "#f5f6fa",
    position: "relative",
  },
  wrapper1: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    overflow: "hidden",
    position: "relative",
    minHeight: "100vh",
    transition: "padding-left 0.3s ease",
    [theme.breakpoints.down("lg")]: {
      paddingLeft: 0,
    },
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    overflow: "hidden",
    position: "relative",
    backgroundColor: "#fff",
    paddingTop: 70,
    minHeight: "100vh",
    transition: "padding-left 0.3s ease",
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 230,
    },
  },
  sidebar: {
    width: 230,
    transition: "width 0.3s ease",
    height: "100vh",
    position: "fixed",
    top: 0,
    left: 0,
    [theme.breakpoints.down("lg")]: {
      width: 0,
      transition: "width 0.3s ease",
    },
  },
  contentContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    overflow: "hidden",
    paddingTop: 75,
  },
  content: {
    flex: "1 1 auto",
    height: "100%",
    overflow: "hidden",
    position: "relative",
    padding: "20px",
    marginLeft: 230,
    transition: "margin-left 0.3s ease",
    "@media (max-width: 1280px)": {
      padding: "10px 20px",
    },
    [theme.breakpoints.down("md")]: {
      marginLeft: 0,
    },
    [theme.breakpoints.down("xs")]: {
      padding: "10px 24px 10px ",
    },
  },
}));

const DashboardLayout = ({ children }) => {
  const classes = useStyles();
  const themeSeeting = useContext(SettingsContext);

  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div
      className={
        themeSeeting.settings.theme === "DARK"
          ? `${classes.root1}`
          : `${classes.root}`
      }
    >
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />

      <div
        className={
          themeSeeting.settings.theme === "DARK"
            ? `${classes.wrapper1}`
            : `${classes.wrapper}`
        }
      >
        <div
          className={classes.sidebar}
          style={{
            width: isSidebarOpen ? "230px" : "0",
            transition: "width 0.3s ease",
          }}
        >
          <Sidebar
            onMobileClose={() => setMobileNavOpen(false)}
            openMobile={isMobileNavOpen}
            isSidebarOpen={isSidebarOpen}
            toggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
          />
        </div>

        <div
          className={classes.contentContainer}
          style={{ paddingTop: isSidebarOpen ? 100 : 100 }}
        >
          <div className={classes.content} id="main-scroll">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
